
import { logInByWechat, is } from "@/utils";
import XButton from 'vux/src/components/x-button/index.vue'


export default {
name: "logInSelection",
created() {

},
data() {
return {
from: this.$route.query.from,
agreeTerms: false
};
},
metaInfo() {
return {
title: "登录",
};
},
methods: {
logInByQQ: function () {
if (!this.agreeTerms) {
this.$vux.toast.show({ text: `请先同意服务协议与隐私政策`, type: 'text' })
return
}

let redirectUrl = "http://m.xczim.com/qqLogIn";
window.location =
"https://graph.qq.com/oauth2.0/authorize?response_type=code&client_id=1105411719&redirect_uri=" +
redirectUrl +
"&state=" +
this.$route.query.from;
},

logInByWeibo: function () {
if (!this.agreeTerms) {
this.$vux.toast.show({ text: `请先同意服务协议与隐私政策`, type: 'text' })
return
}

let redirectUrl = "http://wechat.xichuangzhu.com/weibo-login";
window.location = `https://api.weibo.com/oauth2/authorize?client_id=561916929&redirect_uri=${redirectUrl}&state=${this.from}&display=mobile`;
},

logInByWechat: function () {
if (!this.agreeTerms) {
this.$vux.toast.show({ text: `请先同意服务协议与隐私政策`, type: 'text' })
return
}

logInByWechat(this.from);
},

logInByXCZ: function () {
if (!this.agreeTerms) {
this.$vux.toast.show({ text: `请先同意服务协议与隐私政策`, type: 'text' })
return
}

this.$router.push({
name: "logInByAccount",
query: { from: this.from },
});
},

goToSignUp: function () {
this.$router.push({ name: "signUp", query: { from: this.from } });
},
},
components: {
XButton,
},
};



// WEBPACK FOOTER //
// ./src/pages/account/LogInSelection.vue